import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    height: 40,
    width: 40,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& > *': {
      position: 'absolute',
      bottom: 0,
      // first avatar size is 32*32
      '&:first-child': {
        bottom: -4,
        zIndex: 2,
      },
      // second avatar size is 32*32
      '&:nth-child(2)': {
        left: 6,
        bottom: 14,
        zIndex: 1,
      },
    },
  },
}));

/**
 * This component wraps a list of avatars and render them in a group.
 */
export const AvatarGroup: React.FC = ({ children }): JSX.Element => {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
};
